/**
 * @flow
 */

import {
  SET_PROVIDER_KEY,
  SET_CARD_INSTANCE,
  SET_STRIPE_INSTANCE,
  SET_STRIPE_STATUS
} from './actions';

import { ON_PAYMENT_PLAN_MOUNT_SUCCESS } from '../payment-plans/actions';

const initialState = {
  completed: false,
  providerKey: null,
  cardInstance: null,
  stripeInstance: null,
  config: {
    iconStyle: 'solid',
    style: {
      base: {
        iconColor: '#E2E5E7',
        color: '#1C232B',
        fontWeight: 300,
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
        fontSize: '13px',
        '::placeholder': {
          color: '#A9B0B7'
        }
      },
      invalid: {
        iconColor: '#FC7455',
        color: '#FC7455'
      }
    },
    hidePostalCode: false
  }
};

export default (state: AnyMap = initialState, action: Object): AnyMap => {
  switch (action.type) {

    case ON_PAYMENT_PLAN_MOUNT_SUCCESS:
      return Object.assign({}, state, {
        providerKey: action.payload.ticket.provider_key
      });

    case SET_PROVIDER_KEY:
      return Object.assign({}, state, {
        providerKey: action.payload.key
      });

    case SET_CARD_INSTANCE:
      return Object.assign({}, state, {
        cardInstance: action.payload.card
      });

    case SET_STRIPE_INSTANCE      :
      return Object.assign({}, state, {
        stripeInstance: action.payload.stripe
      });

    case SET_STRIPE_STATUS      :
      return Object.assign({}, state, {
        completed: action.payload.status
      });

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/stripe/reducer.js